import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, ArrowLeft, ArrowRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    document.title = "NOXWAY Journal | Wildfire Preparedness Guides";
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#08090d] text-white" data-testid="blog-page">
      <div className="max-w-4xl mx-auto px-6 py-16 lg:py-24">
        <Link to="/" className="inline-flex items-center gap-2 font-tech text-[10px] tracking-[0.2em] uppercase text-slate-400 hover:text-[#f97316] transition-colors mb-12" data-testid="blog-back">
          <ArrowLeft size={13} /> Back to NOXWAY
        </Link>
        <div className="font-tech text-[11px] tracking-[0.3em] text-[#f97316] uppercase mb-5">The NOXWAY Journal</div>
        <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl mb-4" data-testid="blog-headline">
          Preparedness, <span className="text-[#f97316]">in writing.</span>
        </h1>
        <p className="text-base sm:text-lg text-slate-400 max-w-2xl leading-relaxed mb-16">
          Practical wildfire readiness guides for homeowners — checklists, application walkthroughs and defense strategy.
        </p>

        {posts === null ? (
          <p className="text-slate-500 text-sm">Loading…</p>
        ) : posts.length === 0 ? (
          <p className="text-slate-500 text-sm" data-testid="blog-empty">First guides are being written — check back soon.</p>
        ) : (
          <div className="space-y-5" data-testid="blog-list">
            {posts.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.08 }}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-post-link-${i}`}
                  className="group block card-glow-border rounded-2xl p-7 bg-[#0f1117] hover:border-[#f97316]/40 transition-colors">
                  <div className="flex items-start justify-between gap-6">
                    <div>
                      <h2 className="font-display font-bold text-xl sm:text-2xl mb-2 group-hover:text-[#f97316] transition-colors">{p.title}</h2>
                      <p className="text-sm text-slate-400 leading-relaxed">{p.excerpt}</p>
                      <span className="font-tech text-[10px] tracking-[0.15em] text-slate-600 uppercase mt-3 inline-block">
                        {(p.published_at || "").slice(0, 10)}
                      </span>
                    </div>
                    <ArrowRight size={18} className="text-[#f97316] shrink-0 mt-2 group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}

        <div className="mt-16 flex items-center gap-3 text-slate-600">
          <Flame size={14} />
          <span className="font-tech text-[10px] tracking-[0.2em] uppercase">NOXWAY™ Journal</span>
        </div>
      </div>
    </div>
  );
}
